module.exports = __webpack_public_path__ + "img/video-canvas-card.44e7593a.svg";